// src/app/services/language.service.ts
import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class LanguageService {
  private currentLangSubject = new BehaviorSubject<string>('en');
  currentLang$ = this.currentLangSubject.asObservable();

  // Add direction subject for RTL support
  private directionSubject = new BehaviorSubject<'ltr' | 'rtl'>('ltr');
  direction$ = this.directionSubject.asObservable();

  constructor(private translate: TranslateService) {
    // Load default language from localStorage or use 'en'
    const savedLang = localStorage.getItem('language') || 'en';
    this.setLanguage(savedLang);
  }

  setLanguage(lang: string): void {
    this.translate.use(lang);
    localStorage.setItem('language', lang);
    this.currentLangSubject.next(lang);

    // Determine direction based on language
    const direction = lang === 'ar' ? 'rtl' : 'ltr';
    this.directionSubject.next(direction);

    // Set direction for RTL support
    document.documentElement.lang = lang;
    document.documentElement.dir = direction;
    document.documentElement.setAttribute('dir', direction);

    // Optional: Add RTL CSS class for additional styling
    // if (lang === 'ar') {
    //   document.body.classList.add('rtl');
    // } else {
    //   document.body.classList.remove('rtl');
    // }
  }

  getCurrentLang(): string {
    return this.currentLangSubject.value;
  }

  isRtl(): boolean {
    return this.currentLangSubject.value === 'ar';
  }

  // Add method to get current direction
  getDirection(): 'ltr' | 'rtl' {
    return this.directionSubject.value;
  }
}
